
























































import { Component, Prop, Mixins } from 'vue-property-decorator';
import axios from 'axios';
import copy from 'copy-to-clipboard';
import OfflineMixin from '@/mixins/OfflineMixin';
import generateSignedUrl from '@/helpers/generateSignedUrl';
import download from '@/helpers/download';

@Component({})
export default class DownloadButton extends Mixins(OfflineMixin) {
  @Prop() version!: string;
  @Prop() displayName!: string;
  @Prop() slug!: string;
  @Prop() downloadUrl!: string;
  @Prop({ default: false }) permalinkLabel!: boolean;

  snackbar = false;
  isLoading = false;

  get url(): string | undefined {
    return this.downloadUrl ? generateSignedUrl(this.downloadUrl) : undefined;
  }

  get permalink() {
    return `${window.location.origin}/download/${this.slug}/${this.version}/app`;
  }

  copyPermalink(event: Event) {
    event.preventDefault();

    copy(this.permalink);
    this.snackbar = true;
  }

  async downloadFile(): Promise<void> {
    if (!this.url) {
      return;
    }

    const token = await this.$auth.getTokenSilently({});
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      this.isLoading = true;
      const { data } = await axios.get(this.url, { headers });

      download(data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  }
}
